import { ShieldCheck } from "lucide-react";
import { useSuperadminMetrics, useSuperadminAuditLog } from "@/hooks/use-superadmin";
import { PlatformMetricsCards, TenantPlanBreakdown } from "@/components/superadmin/platform-metrics";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function SuperadminDashboardPage() {
  const metricsQuery = useSuperadminMetrics();
  const auditQuery = useSuperadminAuditLog({ limit: 10 });

  const metrics = metricsQuery.data?.metrics;
  const byPlan = metricsQuery.data?.tenants_by_plan;
  const auditEntries = auditQuery.data?.entries ?? [];

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <ShieldCheck className="h-6 w-6 text-red-500" />
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Platform Admin</h1>
          <p className="text-sm text-muted-foreground">
            Cross-tenant management and platform metrics
          </p>
        </div>
      </div>

      <PlatformMetricsCards metrics={metrics} isLoading={metricsQuery.isLoading} />

      <div className="grid gap-6 lg:grid-cols-2">
        <TenantPlanBreakdown data={byPlan} isLoading={metricsQuery.isLoading} />

        <Card>
          <CardHeader>
            <CardTitle className="text-sm font-medium">Recent Platform Actions</CardTitle>
          </CardHeader>
          <CardContent>
            {auditQuery.isLoading ? (
              <div className="space-y-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="h-6 animate-pulse rounded bg-muted" />
                ))}
              </div>
            ) : auditEntries.length === 0 ? (
              <p className="text-sm text-muted-foreground">No platform actions recorded yet.</p>
            ) : (
              <div className="space-y-2">
                {auditEntries.map((entry) => (
                  <div
                    key={entry.id}
                    className="flex items-center justify-between rounded-md border px-3 py-2 text-sm"
                  >
                    <div>
                      <span className="font-medium">{entry.actor_email}</span>{" "}
                      <span className="text-muted-foreground">{entry.action.replace(/_/g, " ")}</span>
                    </div>
                    <span className="text-xs text-muted-foreground">
                      {new Date(entry.created_at).toLocaleString()}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
